// SuplantarPage.js — «Entrar como» un usuario.
//
// Ruta: /suplantar/:pase (la abre el admin en una pestaña nueva desde Usuarios).
// Canjea el pase de un solo uso por la sesión del usuario y lo deja en sus
// contenidos. La sesión que hubiera en este dominio se guarda y vuelve al salir.
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { suplantacionService } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { guardarRespaldoSesion } from '../utils/suplantacion';

const Pantalla = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem 1.4rem;
  text-align: center;
  background: #f5f7fb;
  color: #0b1f3a;
  font-family: 'Segoe UI', system-ui, sans-serif;
`;

const Titulo = styled.h1`
  margin: 0;
  font-size: 1.2rem;
  color: #0f355b;
`;

const Texto = styled.p`
  margin: 0;
  max-width: 460px;
  color: #5b6779;
  line-height: 1.55;
`;

const Rueda = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid rgba(15, 53, 91, 0.15);
  border-top-color: #0f355b;
  animation: girar 0.9s linear infinite;
  @keyframes girar { to { transform: rotate(360deg); } }
  @media (prefers-reduced-motion: reduce) { animation: none; }
`;

const SuplantarPage = () => {
  const { pase } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');
  // El pase es de un solo uso: que el doble montaje de desarrollo no lo gaste.
  const iniciado = useRef(false);

  useEffect(() => {
    if (iniciado.current) return;
    iniciado.current = true;
    suplantacionService.canjear(pase)
      .then(({ data }) => {
        guardarRespaldoSesion();
        login({ user: data.user, token: data.token });
        navigate('/contenidos', { replace: true });
      })
      .catch((err) => {
        setError(err.response?.data?.message || 'No se pudo entrar como este usuario.');
      });
  }, [pase, login, navigate]);

  return (
    <Pantalla>
      {error ? (
        <>
          <Titulo>No se pudo entrar</Titulo>
          <Texto>{error}</Texto>
        </>
      ) : (
        <>
          <Rueda />
          <Texto>Entrando como el usuario…</Texto>
        </>
      )}
    </Pantalla>
  );
};

export default SuplantarPage;
